/**
 * 预购组件 JavaScript
 * 包含所有与预购相关组件的 JavaScript 功能
 */

// ============================================
// 选择您的配置卡片组件
// ============================================
(function initSelectTrimCard() {
  const trimCards = document.querySelectorAll('.select-trim-card[data-trim-card]');

  if (trimCards.length === 0) return;

  // 默认选择第二个卡片（Atlas）
  const defaultCard = trimCards.length > 1 ? trimCards[1] : trimCards[0];
  defaultCard.classList.add('active');

  // 辅助函数：从 data-time 中提取日期部分（去掉 "Est. delivery: " 前缀）
  function extractDeliveryDate(timeString) {
    if (!timeString) return '';
    return timeString.replace(/^Est\. delivery:\s*/i, '');
  }

  // 更新 delivery 日期的函数
  function updateDeliveryDate(dateString) {
    const deliveryDateElement = document.querySelector('.select-trim-delivery-date');
    if (deliveryDateElement) {
      deliveryDateElement.textContent = dateString;
    }
  }

  // 初始化 delivery 信息（使用默认卡片的 data-time）
  const defaultDeliveryTime = defaultCard.getAttribute('data-time');
  if (defaultDeliveryTime) {
    const dateString = extractDeliveryDate(defaultDeliveryTime);
    updateDeliveryDate(dateString);
  }

  // 触发默认卡片的变体选择器
  const defaultCardType = defaultCard.getAttribute('data-trim-card');
  let defaultVariantSelector;
  if (defaultCardType === 'pioneer') { 
    defaultVariantSelector = '.product__info-container variant-selects > fieldset > label:nth-child(5)';
  } else if (defaultCardType === 'atlas') {
    defaultVariantSelector = '.product__info-container variant-selects > fieldset > label:nth-child(3)';
  }

  if (defaultVariantSelector) {
    // 延迟执行，确保DOM完全加载
    setTimeout(function () {
      const variantLabel = document.querySelector(defaultVariantSelector);
      if (variantLabel) {
        variantLabel.click();
      }
    }, 100);
  }

  trimCards.forEach(card => {
    const header = card.querySelector('.select-trim-card-header');
    const icon = card.querySelector('.select-trim-card-icon');
    const cardType = card.getAttribute('data-trim-card'); // 'pioneer' 或 'atlas'

    // 根据卡片类型确定要点击的变体选择器
    let variantSelector;
    if (cardType === 'pioneer') {
      variantSelector = '.product__info-container variant-selects > fieldset > label:nth-child(5)';
    } else if (cardType === 'atlas') {
      variantSelector = '.product__info-container variant-selects > fieldset > label:nth-child(3)';
    }
 
    // 触发变体选择器点击的函数
    const triggerVariantSelect = function () {
      if (variantSelector) {
        const variantLabel = document.querySelector(variantSelector);
        if (variantLabel) {
          variantLabel.click();
        }
      }
    };

    // 1. 点击 header 只改变背景颜色（只能有一个卡片是 active）
    if (header) {
      header.addEventListener('click', function (e) {
        // 如果点击的是图标，不处理（让图标的事件处理）
        if (e.target.closest('.select-trim-card-icon')) {
          return;
        }

        // 如果当前卡片已经是 active，则不改变状态，但仍然触发变体选择器
        if (!card.classList.contains('active')) {
          // 移除其他所有卡片的 active 类
          trimCards.forEach(otherCard => {
            if (otherCard !== card) {
              otherCard.classList.remove('active');
            }
          });
          // 给当前卡片添加 active 类
          card.classList.add('active');
        }

        // 更新 delivery 信息
        const deliveryTime = card.getAttribute('data-time');
        if (deliveryTime) {
          const dateString = extractDeliveryDate(deliveryTime);
          updateDeliveryDate(dateString);
        }

        // 触发变体选择器（无论是否已经是 active）
        triggerVariantSelect();

        selectTrimCard(card);

        // 当配置改变时触发图片更新
        if (window.updatePreOrderImage) {
          setTimeout(function () {
            window.updatePreOrderImage();
          }, 10);
        }
      });
    }

    // 2. 点击 icon 才展开/收起内容（只能有一个卡片展开）
    if (icon) {
      icon.addEventListener('click', function (e) {
        e.stopPropagation();
        const isExpanded = card.classList.contains('select-trim-card-expanded');

        if (isExpanded) {
          // 如果当前卡片是展开的，则收起
          card.classList.remove('select-trim-card-expanded');
          card.classList.add('select-trim-card-collapsed');
          // 收起时不移除 active 背景色，保持背景色状态
        } else {
          // 收起其他所有卡片
          // trimCards.forEach(otherCard => {
          //   if (otherCard !== card) {
          //     otherCard.classList.remove('select-trim-card-expanded');
          //     otherCard.classList.add('select-trim-card-collapsed');
          //   }
          // });
          
          // 展开当前卡片
          card.classList.remove('select-trim-card-collapsed');
          card.classList.add('select-trim-card-expanded');
          // 展开时自动添加 active 背景色，并移除其他卡片的 active
          trimCards.forEach(otherCard => {
            if (otherCard !== card) {
              otherCard.classList.remove('active');
            }
          });
          card.classList.add('active');

          // 更新 delivery 信息
          const deliveryTime = card.getAttribute('data-time');
          if (deliveryTime) {
            const dateString = extractDeliveryDate(deliveryTime);
            updateDeliveryDate(dateString);
          }

          // 触发变体选择器
          triggerVariantSelect();

          // 当配置改变时触发图片更新
          if (window.updatePreOrderImage) {
            setTimeout(function () {
              window.updatePreOrderImage();
            }, 10);
          }
        }


        openTrimCardDetail(card, isExpanded);
      });
    }
  });
})();

// ============================================
// 车辆信息组件
// ============================================
(function initVehicleDisposition() {
  // 年份输入验证
  const yearInput = document.getElementById('vehicle-year-input');
  if (yearInput) {
    // 仅允许数字输入
    yearInput.addEventListener('input', function (e) {
      let value = e.target.value.replace(/[^0-9]/g, '');
      e.target.value = value;
      console.log('年份输入完成' + e.target.value.length);
      if (e.target.value.length === 4) {
        inputYear(e.target);
      }
    });

    // 在失去焦点时验证年份范围
    yearInput.addEventListener('blur', function (e) {
      const year = parseInt(e.target.value);
      const currentYear = new Date().getFullYear();
      const minYear = 1980;
      const maxYear = currentYear + 1; // 允许当前年份和下一年
      const originalPlaceholder = e.target.placeholder;

      if (e.target.value && (year < minYear || year > maxYear)) {
        // 存储原始占位符
        if (!e.target.dataset.originalPlaceholder) {
          e.target.dataset.originalPlaceholder = originalPlaceholder;
        }

        // 在占位符中显示红色错误消息
        e.target.value = '';
        e.target.placeholder = 'Please enter a valid year between ' + minYear + ' and ' + maxYear + '.';
        e.target.classList.add('error');

        // 3秒后恢复原始占位符
        setTimeout(function () {
          e.target.placeholder = e.target.dataset.originalPlaceholder || originalPlaceholder;
          e.target.classList.remove('error');
        }, 3000);
      } else {
        // 如果输入有效则移除错误类
        e.target.classList.remove('error');
      }
    });

    // 阻止非数字按键
    yearInput.addEventListener('keydown', function (e) {
      // 允许：退格、删除、Tab、Esc、Enter、小数点
      if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
        // 允许：Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (e.keyCode === 65 && e.ctrlKey === true) ||
        (e.keyCode === 67 && e.ctrlKey === true) ||
        (e.keyCode === 86 && e.ctrlKey === true) ||
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // 允许：Home、End、左、右
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        return;
      }
      // 确保是数字并阻止按键
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });
  }

  // Make 到 Model 的映射关系
  const makeToModels = {
    'chevrolet': [
      { value: 'colorado', text: 'Colorado' },
      { value: 'silverado-1500', text: 'Silverado 1500' },
      { value: 'silverado-2500-hd', text: 'Silverado 2500 HD' },
      { value: 'silverado-3500-hd', text: 'Silverado 3500 HD' },
      { value: 'silverado-ev', text: 'Silverado EV' },
      { value: 'others', text: 'Others' }
    ],
    'ford': [
      { value: 'expedition', text: 'Expedition' },
      { value: 'f-150', text: 'F-150' },
      { value: 'f-150-lightning', text: 'F-150 Lightning' },
      { value: 'f-250', text: 'F-250' },
      { value: 'f-350', text: 'F-350' },
      { value: 'ranger', text: 'Ranger' },
      { value: 'others', text: 'Others' }
    ],
    'gmc': [
      { value: 'canyon', text: 'Canyon' },
      { value: 'hummer-ev-pickup-2x', text: 'Hummer EV pickup 2X' },
      { value: 'hummer-ev-pickup-3x', text: 'Hummer EV pickup 3X' },
      { value: 'hummer-ev-suv', text: 'Hummer EV SUV' },
      { value: 'sierra-1500', text: 'Sierra 1500' },
      { value: 'sierra-2500-hd', text: 'Sierra 2500 HD' },
      { value: 'sierra-3500-hd', text: 'Sierra 3500 HD' },
      { value: 'sierra-ev', text: 'Sierra EV' },
      { value: 'yukon', text: 'Yukon' },
      { value: 'others', text: 'Others' }
    ],
    'jeep': [
      { value: 'gladiator', text: 'Gladiator' },
      { value: 'grand-wagoneer', text: 'Grand Wagoneer' },
      { value: 'wagoneer', text: 'Wagoneer' },
      { value: 'others', text: 'Others' }
    ],
    'land-rover': [
      { value: 'defender-90', text: 'Defender 90' },
      { value: 'defender-100', text: 'Defender 100' },
      { value: 'defender-130', text: 'Defender 130' },
      { value: 'others', text: 'Others' }
    ],
    'lexus': [
      { value: 'gx-550', text: 'GX 550' },
      { value: 'lx-600', text: 'LX 600' },
      { value: 'others', text: 'Others' }
    ],
    'nissan': [
      { value: 'armada', text: 'Armada' },
      { value: 'frontier', text: 'Frontier' },
      { value: 'infiniti-qx80', text: 'Infiniti QX80' },
      { value: 'titan', text: 'Titan' },
      { value: 'titan-xd', text: 'Titan XD' },
      { value: 'others', text: 'Others' }
    ],
    'ram': [
      { value: '1500', text: '1500' },
      { value: '1500-rev', text: '1500 REV' },
      { value: '2500', text: '2500' },
      { value: '3500', text: '3500' },
      { value: 'others', text: 'Others' }
    ],
    'rivian': [
      { value: 'r1s', text: 'R1S' },
      { value: 'r1t', text: 'R1T' },
      { value: 'others', text: 'Others' }
    ],
    'tesla': [
      { value: 'cybertruck', text: 'Cybertruck' },
      { value: 'others', text: 'Others' }
    ],
    'toyota': [
      { value: 'sequoia', text: 'Sequoia' },
      { value: 'tacoma', text: 'Tacoma' },
      { value: 'tundra', text: 'Tundra' },
      { value: 'others', text: 'Others' }
    ],
    'others': [
      { value: 'others', text: 'Others' }
    ]
  };

  // 更新 Model 下拉选项的函数
  function updateModelOptions(selectedMake) {
    const modelDropdown = document.querySelector('.vehicle-disposition-dropdown[data-dropdown="model"]');
    if (!modelDropdown) return;

    const modelList = modelDropdown.querySelector('[data-dropdown-list]');
    const modelSelectedText = modelDropdown.querySelector('[data-selected-text]');

    if (!modelList) return;

    // 清空现有的 Model 选项
    modelList.innerHTML = '';

    // 根据选中的 Make 获取对应的 Model 列表
    const models = makeToModels[selectedMake] || [];

    // 创建新的 Model 选项
    models.forEach(model => {
      const item = document.createElement('div');
      item.className = 'vehicle-disposition-dropdown-item';
      item.setAttribute('data-value', model.value);
      item.textContent = model.text;
      modelList.appendChild(item);
    });

    // 重置 Model 的选中状态
    if (modelSelectedText) {
      modelSelectedText.textContent = 'Select model';
      modelSelectedText.classList.add('placeholder');
      modelSelectedText.setAttribute('data-vehicle-content', 'Select model');
    }
    modelDropdown.removeAttribute('data-selected-value');

    // 移除所有 Model 选项的选中状态（虽然已经清空了，但为了保险）
    const modelItems = modelList.querySelectorAll('.vehicle-disposition-dropdown-item');
    modelItems.forEach(item => {
      item.classList.remove('selected');
    });
  }

  // 下拉框功能
  const dropdowns = document.querySelectorAll('.vehicle-disposition-dropdown');

  let brand = '';

  dropdowns.forEach(dropdown => {
    const trigger = dropdown.querySelector('.vehicle-disposition-dropdown-trigger');
    const list = dropdown.querySelector('[data-dropdown-list]');
    const selectedText = dropdown.querySelector('[data-selected-text]');
    const dropdownType = dropdown.getAttribute('data-dropdown');

    // 点击触发器切换下拉框
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();

        // 关闭其他下拉框
        dropdowns.forEach(otherDropdown => {
          if (otherDropdown !== dropdown) {
            otherDropdown.classList.remove('open');
          }
        });

        // 切换当前下拉框
        dropdown.classList.toggle('open');
      });
    }

    // 使用事件委托处理选项选择（因为 Model 选项是动态生成的）
    if (list) {
      list.addEventListener('click', function (e) {
        const item = e.target.closest('.vehicle-disposition-dropdown-item');
        if (!item) return;

        e.stopPropagation();

        const value = item.getAttribute('data-value');
        const text = item.textContent.trim();

        // 更新选中文本
        selectedText.textContent = text;
        selectedText.classList.remove('placeholder');

        // 使用选中的值更新 data-vehicle-content 属性
        if (selectedText.hasAttribute('data-vehicle-content')) {
          selectedText.setAttribute('data-vehicle-content', value);
        }

        // 更新选中状态
        const items = list.querySelectorAll('.vehicle-disposition-dropdown-item');
        items.forEach(otherItem => {
          otherItem.classList.remove('selected');
        });
        item.classList.add('selected');

        // 关闭下拉框
        dropdown.classList.remove('open');

        // 存储选中的值（稍后可用于表单提交）
        dropdown.setAttribute('data-selected-value', value);

        // 如果选择的是 Make，则更新 Model 选项
        if (dropdownType === 'brand') {
          brand = value;
          updateModelOptions(value);
        } else {
          selectTrailer(brand, value);
        }
      });
    }
  });

  // 点击外部时关闭下拉框
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.vehicle-disposition-dropdown')) {
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('open');
      });
    }
  });

  // 按 Esc 键关闭下拉框
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('open');
      });
    }
  });
})();

// ============================================
// 选择您的颜色组件
// ============================================
(function initChooseYourColor() {
  const colorItems = document.querySelectorAll('.choose-color-item');

  if (colorItems.length === 0) return;

  colorItems.forEach((item, index) => {
    item.addEventListener('click', function () {
      // 移除所有选项的选中类
      colorItems.forEach(otherItem => {
        otherItem.classList.remove('selected');
      });

      // 给点击的选项添加选中类
      item.classList.add('selected');

      // 存储选中的颜色值（稍后可用于表单提交）
      const colorValue = item.getAttribute('data-color-value');
      const colorCode = item.getAttribute('data-color');
      console.log('选中的颜色:', colorValue, colorCode);

      // 根据点击的项触发相应的变体选择器
      let variantSelector;
      if (index === 0) {
        // 第一个颜色项：label:nth-child(3)
        variantSelector = '.product__info-container variant-selects > fieldset:nth-child(2) > label:nth-child(3)';
      } else if (index === 1) {
        // 第二个颜色项：label:nth-child(5)
        variantSelector = '.product__info-container variant-selects > fieldset:nth-child(2) > label:nth-child(5)';
      } else if (index === 2) {
        // 第三个颜色项：label:nth-child(7)
        variantSelector = '.product__info-container variant-selects > fieldset:nth-child(2) > label:nth-child(7)';
      }

      // 触发变体选择器点击
      if (variantSelector) {
        setTimeout(function () {
          const variantLabel = document.querySelector(variantSelector);
          if (variantLabel) {
            variantLabel.click();
          }
        }, 10);
      }

      selectColor(colorValue);

      // 当颜色改变时触发图片更新 
      if (window.updatePreOrderImage) {
        window.updatePreOrderImage();
      }
    });
  });
})();

// ============================================
// 根据配置和颜色选择更新预购图片
// ============================================
(function initPreOrderImageUpdate() {
  // 图片映射配置
  // 格式：'配置-颜色' => 图片 URL
  // 您可以根据实际产品图片更新这些 URL
  const imageMap = {
    // Pioneer + 颜色组合
    'pioneer-color-one': 'https://cdn.shopify.com/s/files/1/0950/2192/4716/files/pre-order-Grey-sage.jpg?v=1767586564',
    'pioneer-color-two': 'https://cdn.shopify.com/s/files/1/0950/2192/4716/files/preorder-Glacier-shadow.jpg?v=1767586564',
    'pioneer-color-three': 'https://cdn.shopify.com/s/files/1/0950/2192/4716/files/pre-order-Silver-dune.jpg?v=1767586564',
    // Atlas + 颜色组合
    'atlas-color-one': 'https://cdn.shopify.com/s/files/1/0950/2192/4716/files/pre-order-Grey-sage.jpg?v=1767586564',
    'atlas-color-two': 'https://cdn.shopify.com/s/files/1/0950/2192/4716/files/preorder-Glacier-shadow.jpg?v=1767586564',
    'atlas-color-three': 'https://cdn.shopify.com/s/files/1/0950/2192/4716/files/pre-order-Silver-dune.jpg?v=1767586564'
  };

  // 默认图片（用作后备）
  const defaultImage = 'https://cdn.shopify.com/s/files/1/0950/2192/4716/files/pre-order-Grey-sage.jpg?v=1767586564';

  // 预加载所有图片
  function preloadImages() {
    // 收集所有需要预加载的图片 URL（去重）
    const imageUrls = new Set();
    
    // 添加 imageMap 中的所有图片
    Object.values(imageMap).forEach(url => {
      imageUrls.add(url);
    });
    
    // 添加默认图片
    imageUrls.add(defaultImage);
    
    // 预加载所有图片
    imageUrls.forEach(url => {
      const img = new Image();
      img.src = url;  
      // 可选：监听加载完成事件（用于调试）
      // img.onload = function() { console.log('预加载完成:', url); };
      // img.onerror = function() { console.warn('预加载失败:', url); };
    });
  }

  // 立即开始预加载图片（不等待 DOM 加载）
  preloadImages();

  // 更新预购图片的全局函数（带淡入淡出过渡效果）
  window.updatePreOrderImage = function () {
    const preOrderImage = document.querySelector('.evx-pre-order-image');
    if (!preOrderImage) return;

    // 获取选中的配置
    const activeTrimCard = document.querySelector('.select-trim-card.active');
    const selectedTrim = activeTrimCard ? activeTrimCard.getAttribute('data-trim-card') : null;

    // 获取选中的颜色
    const selectedColorItem = document.querySelector('.choose-color-item.selected');
    const selectedColor = selectedColorItem ? selectedColorItem.getAttribute('data-color') : null;

    // 确定新的图片 URL
    let imageUrl = defaultImage;
    if (selectedTrim && selectedColor) {
      const imageKey = selectedTrim + '-' + selectedColor;
      imageUrl = imageMap[imageKey] || defaultImage;
    } else if (selectedTrim) {
      // 如果仅选择了配置，使用第一个颜色作为默认值
      const imageKey = selectedTrim + '-color-one';
      imageUrl = imageMap[imageKey] || defaultImage;
    }

    // 仅在图片 URL 改变时更新
    if (preOrderImage.src === imageUrl || preOrderImage.getAttribute('data-src') === imageUrl) {
      return;
    }

    // 存储新的图片 URL
    preOrderImage.setAttribute('data-src', imageUrl);

    // 淡出当前图片
    preOrderImage.classList.add('fading-out');

    // 淡出完成后，更改图片并淡入
    setTimeout(function () {
      // 创建新图片进行预加载
      const newImage = new Image();

      newImage.onload = function () {
        // 更新图片源
        preOrderImage.src = imageUrl;
        // 移除淡出类以淡入
        preOrderImage.classList.remove('fading-out');
      };

      newImage.onerror = function () {
        // 如果图片加载失败，仍更新但移除淡出类
        preOrderImage.src = imageUrl;
        preOrderImage.classList.remove('fading-out');
      };

      // 开始加载新图片
      newImage.src = imageUrl;
    }, 400); // 等待淡出过渡完成（0.4秒）
  };

  // 页面加载时初始化图片（使用默认选择）
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(updatePreOrderImage, 100);
    });
  } else {
    setTimeout(updatePreOrderImage, 100);
  }
})();

// ============================================
// 结账按钮功能
// ============================================
(function initCheckoutButton() {
  const checkoutButtons = document.querySelectorAll('.checkout-button');

  if (checkoutButtons.length === 0) return;

  // 为所有按钮绑定鼠标悬停事件
  checkoutButtons.forEach(button => {
    button.addEventListener('mouseover', function () {
      hoverCheckoutButton();
    });
  });

  // 清空购物车和备注的函数
  async function clearCartAndNote() {
    // 1. 清空商品
    await fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' }
    });

    // 2. 清空备注
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        note: ''
      })
    });
  }

  // 设置 loading 状态的辅助函数
  function setLoadingState(buttons, isLoading) {
    buttons.forEach(btn => {
      if (isLoading) {
        btn.classList.add('loading');
        btn.disabled = true;
      } else {
        btn.classList.remove('loading');
        btn.disabled = false;
      }
    });
  }

  // 页面恢复显示时（含浏览器返回 bfcache），确保不会残留 loading 状态
  window.addEventListener('pageshow', function () {
    setLoadingState(checkoutButtons, false);
  });

  // 为所有按钮绑定点击事件
  checkoutButtons.forEach(checkoutButton => {
    checkoutButton.addEventListener('click', async function (e) {
      e.preventDefault();

      checkoutButtonClick('Continue');

      // 防止重复点击
      if (checkoutButton.disabled || checkoutButton.classList.contains('loading')) {
        return;
      }
      
      // 设置所有按钮为 loading 状态
      setLoadingState(checkoutButtons, true);

    try {
      // 获取变体 ID
      const variantIdInput = document.querySelector('.product-variant-id');
      if (!variantIdInput || !variantIdInput.value) {
        console.error('未找到变体 ID');
        setLoadingState(checkoutButtons, false);
        return;
      }
      const variantId = variantIdInput.value;

      // 收集自定义属性
      const properties = {};

      // 1. 选择您的配置 - 从激活的配置卡片的 data-trim-content 获取
      const activeTrimCard = document.querySelector('.select-trim-card.active');
      if (activeTrimCard) {
        const trimTitle = activeTrimCard.querySelector('.select-trim-card-title');
        if (trimTitle && trimTitle.hasAttribute('data-trim-content')) {
          //   properties['Select your trim'] = trimTitle.getAttribute('data-trim-content');
        }
      }

      // 2. 输入年份 - 从输入框的值获取（仅当有值时）
      const yearInput = document.getElementById('vehicle-year-input');
      if (yearInput && yearInput.value && yearInput.value.trim() !== '') {
        properties['Enter year'] = yearInput.value.trim();
      }

      // 3. 选择品牌 - 从品牌下拉框获取（仅当已选择时）
      const brandDropdown = document.querySelector('.vehicle-disposition-dropdown[data-dropdown="brand"]');
      if (brandDropdown) {
        const brandSelectedValue = brandDropdown.getAttribute('data-selected-value');
        const brandSelectedText = brandDropdown.querySelector('[data-selected-text]');
        // 检查下拉框是否已选择（非占位符）
        if (brandSelectedText && !brandSelectedText.classList.contains('placeholder') && brandSelectedValue) {
          properties['Select make'] = brandSelectedValue;
        }
      }

      // 4. 选择型号 - 从型号下拉框获取（仅当已选择时）
      const modelDropdown = document.querySelector('.vehicle-disposition-dropdown[data-dropdown="model"]');
      if (modelDropdown) {
        const modelSelectedValue = modelDropdown.getAttribute('data-selected-value');
        const modelSelectedText = modelDropdown.querySelector('[data-selected-text]');
        // 检查下拉框是否已选择（非占位符）
        if (modelSelectedText && !modelSelectedText.classList.contains('placeholder') && modelSelectedValue) {
          properties['Select model'] = modelSelectedValue;
        }
      }

      // 5. 选择您的颜色 - 从选中的颜色项的 data-color-value 获取
      const selectedColorItem = document.querySelector('.choose-color-item.selected');
      if (selectedColorItem && selectedColorItem.hasAttribute('data-color-value')) {
        // properties['Choose your color'] = selectedColorItem.getAttribute('data-color-value');
      }

      // 为 Shopify cart/add.js 准备 FormData
      const formData = new FormData();
      formData.append('items[0][id]', variantId);
      formData.append('items[0][quantity]', '1');

      // 将属性添加到 FormData 
      Object.entries(properties).forEach(([key, value]) => {
        formData.append(`items[0][properties][${key}]`, value);
      });

      // 先清空购物车和备注
      console.log('正在清空购物车...');
      await clearCartAndNote();
      console.log('购物车已清空');

      // 添加到购物车
      const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!addResponse.ok) {
        throw new Error('网络响应错误');
      }

      const result = await addResponse.json();
      console.log('商品已添加到购物车:', result);

      // 构建备注字符串
      // 格式：Evotrex-PG5 Atlas:$159,990$2000$Chevrolet$Tacoma$Color number one

      // 1. 获取产品名称和配置（从选中卡片的 data-trim-content 属性）
      let productConfig = '';
      if (activeTrimCard) {
        const trimTitle = activeTrimCard.querySelector('.select-trim-card-title');
        if (trimTitle && trimTitle.hasAttribute('data-trim-content')) {
          productConfig = trimTitle.getAttribute('data-trim-content');
        }
      }

      // 2. 获取价格（从页面上的价格显示获取，格式化为带 $ 和逗号）
      let price = '';
      const priceElement = document.querySelector('.price__regular .money, .price__sale .money, #price-main-product .money, [id^="price-"] .money');
      if (priceElement) {
        price = priceElement.textContent.trim();
        // 确保价格格式以 $ 开头
        if (!price.startsWith('$')) {
          // 提取数字并添加 $ 前缀
          const priceMatch = price.match(/[\d,]+\.?\d*/);
          if (priceMatch) {
            price = '$' + priceMatch[0];
          }
        }
      } else {
        // 备用方案：从变体信息获取
        try {
          const variantSelects = document.querySelector('variant-selects [data-selected-variant]');
          if (variantSelects) {
            const variantData = JSON.parse(variantSelects.textContent);
            if (variantData && variantData.price) {
              // 将价格从分转换为元，并格式化
              const priceInDollars = (variantData.price / 100).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              });
              price = priceInDollars;
            }
          }
        } catch (e) {
          console.warn('无法从变体获取价格:', e);
        }
      }

      // 3. 获取年份（如果没有值则为空字符串）
      const year = yearInput && yearInput.value && yearInput.value.trim() !== ''
        ? yearInput.value.trim()
        : '';

      // 4. 获取品牌（如果没有值则为空字符串）
      let brand = '';
      if (brandDropdown) {
        const brandSelectedValue = brandDropdown.getAttribute('data-selected-value');
        const brandSelectedText = brandDropdown.querySelector('[data-selected-text]');
        if (brandSelectedText && !brandSelectedText.classList.contains('placeholder') && brandSelectedValue) {
          brand = brandSelectedValue;
        }
      }

      // 5. 获取型号（如果没有值则为空字符串）
      let model = '';
      if (modelDropdown) {
        const modelSelectedValue = modelDropdown.getAttribute('data-selected-value');
        const modelSelectedText = modelDropdown.querySelector('[data-selected-text]');
        if (modelSelectedText && !modelSelectedText.classList.contains('placeholder') && modelSelectedValue) {
          model = modelSelectedValue;
        }
      }

      // 6. 获取颜色（如果没有值则为空字符串）
      let color = '';
      if (selectedColorItem && selectedColorItem.hasAttribute('data-color-value')) {
        color = selectedColorItem.getAttribute('data-color-value');
      }

      // 构建备注字符串，格式：产品配置&年份&品牌&型号&颜色
      // 即使字段为空，也保留 & 分隔符位置
      const cartNote = `${productConfig}&${year}&${brand}&${model}&${color}`;

      console.log('生成的购物车备注:', cartNote);

      // 更新购物车备注
      const updateNoteResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          note: cartNote
        })
      });

      if (!updateNoteResponse.ok) {
        console.warn('更新购物车备注失败');
      } else {
        console.log('购物车备注已更新');
      }

      // 设置订单属性（attributes），这些属性会在结账时传递到订单中
      const orderAttributes = {
        'select_your_trim': productConfig || '',
        'choose_your_color': color || '',
        'enter_year': year || '',
        'select_make': brand || '',
        'select_model': model || ''
      };

      // 更新购物车属性
      const updateAttributesResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: orderAttributes
        })
      });

      if (!updateAttributesResponse.ok) {
        console.warn('更新订单属性失败');
      } else {
        console.log('订单属性已更新:', orderAttributes);
      }

      // 在跳转前清理 loading，避免返回页面时按钮仍处于转圈状态
      setLoadingState(checkoutButtons, false);

      // 跳转到结账页面
      window.location.href = window.Shopify.routes.root + 'checkout';

    } catch (error) { 
      console.error('结账过程中出错:', error);
      // 出错时移除 loading 状态并重新启用所有按钮
      setLoadingState(checkoutButtons, false);
    }
    });
  });
})();

// ============================================
// 预购图片返回按钮功能
// ============================================
(function initPreOrderBackButton() {
  const backButton = document.querySelector('.evx-pre-order-back-button');

  if (!backButton) return;

  backButton.addEventListener('click', function (e) {
    e.preventDefault();

    // 获取当前页面的域名和完整 URL
    const currentOrigin = window.location.origin;
    const currentHref = window.location.href;

    // 检查 referrer 是否存在且来自同一域名，且不是当前页面
    const referrer = document.referrer;
    const hasValidReferrer = referrer &&
      referrer !== currentHref &&
      referrer.startsWith(currentOrigin) &&
      referrer.trim() !== '';

    // 检查历史记录长度（大于1表示有上一页）
    const hasHistory = window.history.length > 1;

    // 如果 referrer 存在且有效，或者有历史记录，尝试返回上一页
    if (hasValidReferrer || hasHistory) {
      // 尝试返回上一页
      try {
        window.history.back();
        // 如果 history.back() 没有效果（比如新标签页），延迟后跳转到首页
        setTimeout(function() {
          // 检查是否还在当前页面（如果返回成功，URL 应该已经改变）
          if (window.location.href === currentHref) {
            window.location.href = 'https://www.evotrex.com/';
          }
        }, 100);
      } catch (error) {
        // 如果 history.back() 失败，跳转到首页
        window.location.href = 'https://www.evotrex.com/'; 
      }
    } else {
      // 没有有效的 referrer 和历史记录（直接访问、新标签页打开等），返回首页
      window.location.href = 'https://www.evotrex.com/';
    }
  });
})();

// ============================================
// Deposit Popup 触发事件绑定
// ============================================
(function initDepositPopupTriggers() {
  // 等待 DOM 加载完成
  function init() {
    // 查找所有 deposit-popup section
    const depositPopupSections = document.querySelectorAll('.deposit-popup-section[data-section-id]');

    if (depositPopupSections.length < 2) {
      // 如果没有找到足够的 section，延迟重试
      setTimeout(init, 100);
      return;
    }

    // 第一个 deposit-popup section
    const firstPopupSection = depositPopupSections[0];
    const firstSectionId = firstPopupSection.getAttribute('data-section-id');

    // 第二个 deposit-popup section
    const secondPopupSection = depositPopupSections[1];
    const secondSectionId = secondPopupSection.getAttribute('data-section-id');

    // 1. 绑定 .checkout-info-icon 点击事件到第一个 popup
    const checkoutInfoIcon = document.querySelectorAll('.checkout-info-icon');
    if (checkoutInfoIcon && firstSectionId) {
      checkoutInfoIcon.forEach(icon => {
        icon.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // 触发第一个 popup
        const openFunction = window['openDepositPopup_' + firstSectionId];
        if (openFunction && typeof openFunction === 'function') {
          openFunction();
        } 
      });
      });
    }

    // 2. 绑定 .select-trim-icon 点击事件到第二个 popup
    const selectTrimIcon = document.querySelector('.select-trim-icon');
    if (selectTrimIcon && secondSectionId) {
      selectTrimIcon.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // 获取 .select-trim-delivery-date 的值（日期部分）
        const deliveryDateElement = document.querySelector('.select-trim-delivery-date');
        let deliveryValue = '';
        if (deliveryDateElement) {
          deliveryValue = deliveryDateElement.textContent.trim();
        } else {
          // 如果没有找到日期元素，尝试从完整的 delivery 元素中提取
          const deliveryElement = document.querySelector('.select-trim-delivery');
          if (deliveryElement) {
            const fullText = deliveryElement.textContent.trim();
            // 移除 "Est delivery: " 前缀，只保留日期部分
            deliveryValue = fullText.replace(/^Est\.?\s*delivery:\s*/i, '');
          }
        }

        // 更新第二个弹框的 deposit-popup-title-amount-date（只更新日期部分）
        if (secondSectionId) {
          const titleAmountDateElement = secondPopupSection.querySelector('.deposit-popup-title-amount-date');
          if (titleAmountDateElement && deliveryValue) {
            titleAmountDateElement.textContent = deliveryValue;
          }

          // 同步更新 description_1 段落里所有的加粗元素（strong / b）
          const description1El = secondPopupSection.querySelector('.deposit-popup-description-1');
          if (description1El && deliveryValue) {
            const boldEls = description1El.querySelectorAll('strong, b');
            boldEls.forEach(function (boldEl) {
              boldEl.textContent = deliveryValue;
            });
          }
        }

        // 触发第二个 popup
        const openFunction = window['openDepositPopup_' + secondSectionId];
        if (openFunction && typeof openFunction === 'function') {
          openFunction();
        }
      });
    }
  }

  // 页面加载时初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 200);
    });
  } else {
    setTimeout(init, 200);
  }
})();



